<script setup lang="ts">
import type { ListboxFilterProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { ArrowPathIcon, MagnifyingGlassIcon } from '@heroicons/vue/20/solid'
import { reactiveOmit } from '@vueuse/core'
import { ListboxFilter, useForwardProps } from 'reka-ui'
import { cn } from '#ui-kit/lib/utils'

defineOptions({
  inheritAttrs: false,
})

const props = defineProps<
  ListboxFilterProps & {
    class?: HTMLAttributes['class']
    loading?: boolean
  }
>()

const searchModel = defineModel<string>({ default: '' })

const delegatedProps = reactiveOmit(props, 'class', 'loading')

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <div class="flex h-10 items-center gap-3 border-b border-divider px-3" cmdk-input-wrapper>
    <ArrowPathIcon v-if="loading" class="size-4 shrink-0 text-muted-fg animate-spin" />
    <MagnifyingGlassIcon v-else class="size-4 shrink-0 text-muted-fg" />
    <ListboxFilter
      v-bind="{ ...forwardedProps, ...$attrs }"
      v-model="searchModel"
      auto-focus
      :class="
        cn(
          'flex h-full w-full bg-transparent text-sm outline-hidden placeholder:text-placeholder disabled:cursor-not-allowed disabled:opacity-50',
          props.class,
        )
      "
    />
  </div>
</template>
